import { makeStyles } from '@material-ui/core/styles'

// Previously imported from ../Promotions/styles. A screen reaching into another screen's
// style module couples the two: the Promotions list was rebuilt around a div-grid table and
// no longer needs `detailHeader` or `paper` at all, but could not drop them without silently
// restyling this screen. One styles module per screen, per portal-ux-conventions.md section 9.
export default makeStyles((theme) => ({
  detailHeader: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2)
  },
  // Matches the visuallyHidden pattern already used in InventoryAllocateAvailability
  // and ReportingPayment — the standard clip-rect technique, not a new invention.
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1
  },
  paper: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    overflowX: 'auto'
  }
}))
